import { PRESCREENING } from '@/constants';
import { faker } from '@faker-js/faker';

const states = Object.values(PRESCREENING.APPROVAL_KEY);

const mockApprovalState = (approvalKey, description) => {
  const item = {
    id: faker.string.uuid(),
    approval_key: approvalKey,
    description: description,
  };
  return item;
};

const mockApprovalStates = () =>
  new Array(states.length)
    .fill(null)
    .map((_el, i) => mockApprovalState(states[i], states[i].toLowerCase()));

export { mockApprovalState, mockApprovalStates };
